import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="Y" transform="translate(11.000000, 5.000000)">
        <path
          d="M28.541667,30 L39.291667,45 L50.691667,30 L50.691667,33 L39.291667,48 L39.291667,61 L33.591667,61 L33.591667,48 L22.541667,33 L22.541667,30 L28.541667,30"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
